/* Lisa Kookt (03-11-2026): staffelkorting op de productkaart.
   Hoort bij snippets/lk-cardstaffel.liquid. Geladen via snippets/lk-productfix.liquid.

   - Aantal-stepper op de kaart omhoog: de kaartprijs wordt de stuksprijs van
     die staffeltrede en het regeltje eronder wordt "4% korting · totaal €11,04".
   - Terug naar 1: alles terug naar de standaardtekst ("€5,17 p/s vanaf 8 broden").
   - Variantkeuze op de kaart (bv. 400 gram -> 2000 gram): basisprijs gaat mee.

   Afronding: in euro's met toFixed(2), net als de volumetegels op de
   productpagina (8 x 5,75 met 10% korting = 5,17 p/s, totaal 41,36). Bij
   boot wordt elk regeltje meteen herschreven zodat kaart en productpagina
   dezelfde cijfers tonen. */
(function () {
  'use strict';

  function eur(v) {
    return '€' + v.toFixed(2).replace('.', ',');
  }

  function unitPrice(baseCents, pct) {
    return +(((baseCents / 100) * (100 - pct)) / 100).toFixed(2);
  }

  function parseTiers(str) {
    var out = [];
    String(str || '').split(',').forEach(function (p) {
      var kv = p.split('=');
      var q = parseInt(kv[0], 10), pc = parseFloat(kv[1]);
      if (q > 0 && pc > 0) out.push({ q: q, pct: pc });
    });
    out.sort(function (a, b) { return a.q - b.q; });
    return out;
  }

  function pctFor(tiers, qty) {
    var pct = 0;
    for (var i = 0; i < tiers.length; i++) if (qty >= tiers[i].q) pct = tiers[i].pct;
    return pct;
  }

  function defaultText(box) {
    var base = parseInt(box.getAttribute('data-lk-base'), 10) || 0;
    var tiers = parseTiers(box.getAttribute('data-lk-tiers'));
    var top = tiers.length ? tiers[tiers.length - 1] : null;
    var unit = box.getAttribute('data-lk-unit') || 'stuks';
    if (!top || !base) return box.getAttribute('data-lk-default') || '';
    return eur(unitPrice(base, top.pct)) + ' p/s vanaf ' + top.q + ' ' + unit;
  }

  function update(box) {
    var key = box.getAttribute('data-lk-key');
    var card = box.closest('.card-wrapper');
    if (!card) return;
    var input = card.querySelector('input.quantity__input');
    var qty = input ? parseInt(input.value, 10) || 1 : 1;
    var base = parseInt(box.getAttribute('data-lk-base'), 10) || 0;
    var tiers = parseTiers(box.getAttribute('data-lk-tiers'));
    var pct = pctFor(tiers, qty);
    var priceEls = card.querySelectorAll('#price-' + key + ' .price__regular .price-item--regular, #price-' + key + ' .price-item--sale');

    if (pct > 0 && base > 0) {
      var unit = unitPrice(base, pct);
      for (var i = 0; i < priceEls.length; i++) priceEls[i].textContent = eur(unit);
      box.textContent = pct + '% korting · totaal ' + eur(+(unit * qty).toFixed(2));
      box.classList.add('is-active');
    } else {
      if (base > 0) for (var k = 0; k < priceEls.length; k++) priceEls[k].textContent = eur(base / 100);
      box.textContent = defaultText(box);
      box.classList.remove('is-active');
    }
  }

  function initAll(root) {
    var list = (root || document).querySelectorAll('.lk-cstaffel:not([data-lk-init])');
    for (var i = 0; i < list.length; i++) {
      list[i].setAttribute('data-lk-init', '1');
      update(list[i]);
    }
  }

  // aantal gewijzigd (plus/min dispatcht een bubbelend change-event op het veld)
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
    var card = input.closest('.card-wrapper');
    var box = card && card.querySelector('.lk-cstaffel');
    if (box) update(box);
  }, true);

  // variant gewisseld op de kaart: basisprijs bijwerken
  function onVariantChange(event) {
    var d = event && event.data;
    if (!d || !d.sectionId || !d.variant) return;
    var boxes = document.querySelectorAll('.lk-cstaffel[data-lk-key="' + d.sectionId + '"]');
    for (var i = 0; i < boxes.length; i++) {
      if (typeof d.variant.price === 'number') {
        boxes[i].setAttribute('data-lk-base', d.variant.price);
        // het thema herschrijft de prijs zelf na de wissel; even wachten en dan onze trede opnieuw toepassen
        (function (b) { window.setTimeout(function () { update(b); }, 150); })(boxes[i]);
      }
    }
  }

  function boot() {
    initAll(document);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var k = 0; k < added.length; k++) {
            if (added[k].nodeType === 1) initAll(added[k].parentNode || document);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () { initAll(document); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
